/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCustomer
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCustomer {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCustomer
     */
    familyName?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCustomer
     */
    firstName?: string;
}

export function JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCustomerFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCustomer {
    return JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCustomerFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCustomerFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCustomer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'familyName': !exists(json, 'familyName') ? undefined : json['familyName'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCustomerToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseCustomer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'familyName': value.familyName,
        'firstName': value.firstName,
    };
}

